module.exports = __webpack_public_path__ + "img/avatar-10.84f3fa03.jpg";